const addComma = (Number, character = ',') => {
  if (typeof Number == 'number') return Number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, character);
};
export default addComma;

export function nFormatter(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(2).replace(/\.0$/, '') + ' میلیون';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + ' هزار';
  }
  return num;
}
